import React, { Fragment, useEffect } from "react";
import { getCookie } from "../../modules/utils/cookie";
import { _O } from "../../modules/utils";

export default (props) => {
  useEffect(() => {
    if (props.match.params.UID === getCookie("UID")) {
      _O.Open("/membership/newNum");
    } else {
      alert("계정 정보가 일치하지 않습니다.");
      _O.Open("/mp/myInfo/view");
    }
  }, []);

  return (
    <Fragment>
      <div>
        <div onClick={() => _O.Open("/")}>홈으로</div>
      </div>
    </Fragment>
  );
};
